export default function Pulse() {
  return (
    <div className=" border  rounded-md p-4 max-w-sm w-full mx-auto">
      <div className=" flex space-x-4">
        <div className="flex-1 space-y-6 py-1">
          <div className="h-3 bg-slate-200 rounded"></div>
          <div className="h-3 bg-slate-200 rounded"></div>
          <div className="h-3 bg-slate-200 rounded"></div>
          <div className="h-3 bg-slate-200 rounded"></div>
        </div>
      </div>
    </div>
  );
}
